export const useSearchResultsList = ({ data, queries, preloadSearch, isPreviousQueriesEnabled, }) => {
    const hasData = !!data?.length;
    const hasPreloadData = !!preloadSearch?.data?.length;
    const results = hasData
        ? data
        : hasPreloadData
            ? preloadSearch.data
            : isPreviousQueriesEnabled
                ? queries
                : [];
    const hasResults = !!results?.length;
    return { results, hasResults, hasData: hasData || hasPreloadData };
};
